import React, { useCallback, useState } from 'react';
import useMountEffect from '../../hooks/useMountEffect';
import InlineTreeFilter from './InlineTreeFilter';

const defaultPagination = { current: 1, pageSize: 50 };

const arrDataToTreeData = (arrData: any[]): any[] => {
	if (!Array.isArray(arrData)) {
		return [];
	}
	return arrData.map((node) => ({
		value: node.id,
		key: node.id,
		title: node.name,
		hierarchyName: node.hierarchyName || node.name,
		children:
			Array.isArray(node.children) && node.children.length > 0
				? arrDataToTreeData(node.children)
				: [],
	}));
};

interface ProblemTypeInlineFilterProps {
	fetchData: (
		searchText: string,
		targetCollectionName: string,
		pagination?: any,
		sorting?: any,
		filters?: any,
		addToTargetCollection?: boolean
	) => Promise<any[]>;
	targetCollectionName: string;
	value?: Array<string | number>;
	onChange?: (values: Array<string | number>) => void;
	placeholder?: string;
}

const ProblemTypeInlineFilter: React.FC<ProblemTypeInlineFilterProps> = ({
	fetchData,
	targetCollectionName,
	value,
	onChange,
	placeholder = 'Search for a problem type',
}) => {
	const [treeData, setTreeData] = useState<any[]>([]);
	const [loading, setLoading] = useState(true);

	const loadProblemTypes = useCallback(
		(searchText: string) => {
			setLoading(true);
			fetchData(searchText, targetCollectionName, defaultPagination, undefined, undefined, false)
				.then((arrData) => {
					setTreeData(arrDataToTreeData(arrData || []));
					setLoading(false);
				})
				.catch(() => setLoading(false));
		},
		[fetchData, targetCollectionName]
	);

	useMountEffect(() => {
		loadProblemTypes('');
	});

	return (
		<InlineTreeFilter
			treeData={treeData}
			value={value}
			onChange={onChange}
			onSearch={loadProblemTypes}
			placeholder={placeholder}
			searchProp="hierarchyName"
			loading={loading}
		/>
	);
};

export default ProblemTypeInlineFilter;
